import axios from "axios";
import {formDataHandler} from "@/services/form";

const errorsHandler = require("@/services/errors")

//Change This
const module = 'bookings'

const state = {
    filter: {
        center_id: null,
        field_id: null,
        code: null,
        sport_id: null,
        status: null,
        promo_sa_global: null,
        created_from: null,
        created_to: null,
        booking_from: null,
        booking_to: null,
        customer_q: null,
    },
    options_pagination: {
        page: 1,
        limit: 10
    },
    management: null
}

const getters = {
    getFilter: state => {
        return state.filter
    },

    getOptionsPagination: state => {
        return state.options_pagination
    },

    getManagement: state => {
        return state.management
    },
}

const actions = {
    index: async (context, payload) => {

        let url = `api/v1/${module}`;

        var params = ''

        params = `?page=${context.state.options_pagination.page}&limit=${context.state.options_pagination.limit}`

        if (context.state.filter.center_id) {
            params += `&center_id=${context.state.filter.center_id}`
        }

        if (context.state.filter.field_id) {
            params += `&field_id=${context.state.filter.field_id}`
        }

        if (context.state.filter.sport_id) {
            params += `&sport_id=${context.state.filter.sport_id}`
        }

        if (context.state.filter.code) {
            params += `&code=${context.state.filter.code}`
        }

        if (context.state.filter.status) {
            params += `&status=${context.state.filter.status}`
        }

        if (!context.rootGetters['user/getUser'].super_admin) {
            params += `&center_id=${context.rootGetters['user/getUser'].center_id}`
        }

        if (context.state.filter.user_id && context.rootGetters['user/getUser'].super_admin) {
            params += `&user_id=${context.state.filter.user_id}`
        }

        if (context.state.filter.promo_sa_global && context.rootGetters['user/getUser'].super_admin) {
            params += `&promo_sa_global=${context.state.filter.promo_sa_global}`
        }

        if (context.state.filter.customer_q) {
            params += `&customer_q=${encodeURIComponent(context.state.filter.customer_q)}`;
        }

        if (context.state.filter.created_from) {
            params += `&created_from=${encodeURIComponent(context.state.filter.created_from)}`;
        }
        if (context.state.filter.created_to) {
            params += `&created_to=${encodeURIComponent(context.state.filter.created_to)}`;
        }

        if (context.state.filter.booking_from) {
            params += `&booking_from=${encodeURIComponent(context.state.filter.booking_from)}`;
        }
        if (context.state.filter.booking_to) {
            params += `&booking_to=${encodeURIComponent(context.state.filter.booking_to)}`;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}${params}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    store: async (context, payload) => {

        let url = `api/v1/${module}/store/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    edit: async (context, payload) => {

        let url = `api/v1/${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    update: async (context, payload) => {

        let url = `api/v1/${module}/update/${payload.id}`;

        var formData = await formDataHandler(payload.item)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    delete: async (context, payload) => {

        let url = `api/v1/${module}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, {}, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    massDelete: async (context, payload) => {

        let url = `api/v1/${module}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    getCalendar: async (context, payload) => {

        let url = `api/v1/${module}/view-calendar/${payload.center_slug}/${payload.field_slug}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    rollback: async (context, payload) => {

        let url = `api/v1/${module}/rollback/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {success: true}

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    confirm: async (context, payload) => {

        let url = `api/v1/${module}/confirm/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {success: true}

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    complete: async (context, payload) => {

        let url = `api/v1/web/complete-booking/${payload.code}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    cancel: async (context, payload) => {

        let url = `api/v1/cancellations/make-request-admin/`;

        var formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: result.data,
            }

        }).catch(error => {

            return {
                success: false,
                message: error.response.data
            }

        });

    },

    fetchCalendar: async (context, payload) => {
        let url
        if(!payload.date){
            url = `api/v1/web/get-field-by-id/${payload.id}`;
        }else{
            url = `api/v1/web/get-field-live-calendar/${payload.id}/${payload.date}/${payload.days}`;
        }

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                "Content-Type": "application/json"
            },
        ).then(result => {

            if (result.data.result) {

                let visible = []
                for (let i = 0; i <= 6; i++) {
                    visible[i] = result.data.result.calendar.days[i]
                }

                let weeks_num = result.data.result.calendar.days.length / 7
                let weeks = []

                let end_idx = result.data.result.calendar.days.length - 1
                for (let i = 0; i < Math.ceil(weeks_num); i++) {
                    let start_index = i * 7
                    let end_index = i * 7 + 6
                    weeks.push({
                        ref: i,
                        start: start_index,
                        end: end_index,
                        start_date: result.data.result.calendar.days[start_index].date,
                        end_date: (result.data.result.calendar.days[end_index]) ? result.data.result.calendar.days[end_index].date : result.data.result.calendar.days[end_idx].date
                    })
                }

                return {
                    weeks_num: Math.ceil(weeks_num),
                    weeks: weeks,
                    visible: visible,
                    center: result.data.result.center,
                    field: result.data.result.field,
                    calendar: result.data.result.calendar,
                    sport_selected: result.data.result.field.sports[0]._id
                }

            } else {
                return false
            }


        }).catch(error => {

            return {
                success: false,
                message: error.response.data
            }

        });

    },

    getActiveBookings : async (context,payload) => {

        let url = `api/v1/${module}/get-active-bookings/`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data.result
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },

    setFilter: async (context, value) => {
        context.commit('SET_FILTER', value)
    },

    setOptionsPagination: async (context, value) => {
        context.commit('SET_OPTIONS_PAGINATION', value)
    },
    setManagement: async (context, value) => {
        context.commit('SET_MANAGEMENT', value)
    },
}

const mutations = {
    SET_FILTER: (state, value) => {
        state.filter = value
    },
    SET_OPTIONS_PAGINATION: (state, value) => {
        state.options_pagination = value
    },
    SET_MANAGEMENT: (state, value) => {
        state.management = value
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

